import React from 'react';
import styled from 'styled-components';
import Element from './element';

const Select = ({
  className,
  name,
  currentValue = '',
  handler,
  defaultOptionTitle = '...',
  alwaysShowDefaultOption = false,
  options = [],
  withCount = false,
  disabledWhenNoOptions = false,
  required = false,
  toLocaleString = false,
  ...props
}) => (
  <Element
    className={className}
    name={name}
    disabled={disabledWhenNoOptions ? options.length === 0 : false}
    required={required}
    {...(handler ? {
      value: currentValue,
      onChange: handler,
    } : {})}
    {...props}
  >
    {(!required || alwaysShowDefaultOption) && <option value="">{defaultOptionTitle}</option>}
    {options.map((option) => {
      if (typeof option === 'string' || typeof option === 'number') {
        return <option key={option} value={option}>{toLocaleString ? option.toLocaleString('nl-NL') : option}</option>;
      }
      const { value, name: title, count } = option;
      return (
        <option key={title} value={value || title}>
          {title}{withCount && count && ` (${count})`}
        </option>
      );
    })}
  </Element>
);

export default styled(Select)``;
